export default __webpack_public_path__ + "static/aap-red-nl~bexvtiOu-f35764fb6de3f733da8f3a5e7faf6196.png";